import React, { Component } from "react";
import { Auth } from "aws-amplify";
import Spacer from "../components/Spacer";
import * as prosConnect from "../prodect/ProsConnect";
import {isValidCode, isValidEmail, isValidPassWord, PROS_PASSWORD_RULES} from "../prodect/ProsCommonUi";
import {prosNotificationShow} from "../prodect/ProsPopup";
import TextInput from "../components/TextInput";
import BasicButton from "../components/BasicButton";
import {prosAppNotifWarnConfirm} from "../prodect/ProsAppNotif";
import {prosLogErr} from "../prodect/ProsConnect";


export default class AuthForgotPwd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            email: prosConnect.getUserEmail(true) ? prosConnect.getUserEmail(true) : "",
            name: prosConnect.getUserName() ? prosConnect.getUserName() : "",
            password: "",
            confirmPassword: "",
            confirmationCode: "",
            promptCode: false
        };
    }

    validateForm() {
        return this.state.email &&
            isValidEmail(this.state.email, true) &&
            isValidPassWord(this.state.password) &&
            this.state.password === this.state.confirmPassword
    }

    handleKeyDown =(evt)=> {
        if (evt.key === 'Enter'){
            evt.preventDefault()
            this.handleSubmit()
        }
    }

    handleChange = (id, val) => {
        this.setState({
            [id]: val
        })
    }

    handleSubmit = async ()=> {
        this.setState({ isLoading: true });
        try {
            await Auth.forgotPassword(this.state.email);
            this.setState({
                promptCode: true
            })
        } catch (e) {
            prosAppNotifWarnConfirm("Virhe - tarkista s-postiosoite: " + e.message);
            prosLogErr("Forgot pwd failed with message", e.message)
        }
        this.setState({ isLoading: false });
    }

    handleConfirmationSubmit = async ()=> {
        this.setState({ isLoading: true });
        try {
            await Auth.forgotPasswordSubmit(this.state.email, this.state.confirmationCode, this.state.password);
            await Auth.signIn(this.state.email, this.state.password);
            prosConnect.setUserEmail(this.state.email);
            this.props.userHasAuthenticated(true);
            this.props.history.push("/");
        } catch (e) {
            prosNotificationShow(this, e.message);
            this.setState({ isLoading: false });
        }
    };

    renderPasswordFields(){
        return <>
            <TextInput
                id={"password"}
                type={"password"}
                label={"Uusi salasana"}
                value={this.state.password}
                onChange={(val)=> this.handleChange('password', val)}
                placeholder={"········"}
                required
                isValid={isValidPassWord(this.state.password)}
                info={PROS_PASSWORD_RULES}
                onKeyDown={this.handleKeyDown}
            />
            <TextInput
                id={"confirmPassword"}
                type="password"
                label={"Vahvista uusi salasana"}
                value={this.state.confirmPassword}
                onChange={(val)=> this.handleChange('confirmPassword', val)}
                placeholder={"Salasana uudestaan"}
                required
                isValid={this.state.password === this.state.confirmPassword}
                onKeyDown={this.handleKeyDown}
                disabled={!isValidPassWord(this.state.password)}
            />
            <Spacer/>
        </>
    }

    renderConfirmationForm() {
        return (
            <>
                <header>
                    <h1>Aseta uusi salasana ja vahvistuskoodi</h1>
                    <div className={"msg"}>
                        <p>Vahvistuskoodi on lähetetty sähköpostiisi.</p>
                    </div>
                </header>
                <section>
                    <form onSubmit={(evt)=>{
                        evt.preventDefault()
                        this.handleConfirmationSubmit()
                    }}>
                        {this.renderPasswordFields()}
                        <TextInput
                            id="confirmationCode"
                            label={"Vahvistuskoodi"}
                            autoFocus
                            type={"number"}
                            inputMode={"numeric"}
                            value={this.state.confirmationCode}
                            onChange={(val)=>this.handleChange('confirmationCode', val)}
                            placeholder={"Vahvistuskoodi"}
                            required
                            isValid={isValidCode(this.state.confirmationCode)}
                            onKeyDown={(evt)=>{
                                if (evt.key === 'Enter') {
                                    evt.preventDefault()
                                    this.handleConfirmationSubmit()
                                }
                            }}
                        />
                        <div className={"btn-set_center"}>
                            <BasicButton
                                btnClass={"primary"}
                                icon={isValidCode(this.state.confirmationCode) ? "check" : null}
                                label={this.state.isLoading ? "Tarkistetaan" : "Tarkista"}
                                disabled={!isValidCode(this.state.confirmationCode)}
                                buttonType={"submit"}
                                loading={this.state.isLoading}
                            />
                        </div>
                        <Spacer size={"lg"}/>
                    </form>
                </section>
            </>
        );
    }

    renderForm() {
        return <>
            <header>
                <h1>Anna emailosoitteesi</h1>
            </header>
            <section>
                <form onSubmit={(evt)=>{
                    evt.preventDefault()
                    this.handleSubmit()
                }}>
                    <TextInput
                        id={"email"}
                        type="email"
                        label={"Sähköposti"}
                        autoFocus
                        value={this.state.email}
                        onChange={(val)=> this.handleChange('email', val)}
                        placeholder={"Sähköpostiosoitteesi"}
                        required
                        isValid={isValidEmail(this.state.email, true)}
                        onKeyDown={this.handleKeyDown}
                    />
                    <div className={"btn-set_center"}>
                        <BasicButton
                            btnClass={"primary"}
                            icon={this.validateForm() ? "check" : null}
                            label={this.state.isLoading ? "Tarkistetaan" : "Tilaa vahvistuskoodi"}
                            disabled={!isValidEmail(this.state.email, true)}
                            buttonType={"submit"}
                            loading={this.state.isLoading}
                        />
                    </div>
                </form>
            </section>
        </>
    }

    render() {
        return <>
            <div className={"mini-page"}>
                {this.state.promptCode
                    ? this.renderConfirmationForm()
                    : this.renderForm()}
            </div>
        </>
    }
}
